/* global google */

export default google.maps.ControlPosition;



// WEBPACK FOOTER //
// ./src/common/components/BetterMap/ControlPosition.js